import { View } from './view'

export const Image = View
